import React  from 'react';

import Date from './Date';
import DateRange from './DateRange';

class Datepicker extends React.Component {
  render() {
    const {
      defaultDate,
      handleChange
    } = this.props;

    const date = defaultDate ? (
      defaultDate.length === 2 ? (
        <DateRange
          defaultValue={defaultDate}
          handleChange={handleChange}
          allowClear={false}
        />
      ) : (
        <Date
          defaultValue={defaultDate}
          handleChange={handleChange}
        />
      )
    ) : null;

    return date;
  }
}

export default Datepicker;
